@if (shop && (platform$ | async); as platform) {
  <a class="shop no-drag" [routerLink]="!utils.isDesktop ? shopUrl : undefined">
    <div class="shop__image">
      <app-image
        [img]="(shop.avatar?.previewNormal | addBaseUrl) || '/assets/images/befree.png'"
      ></app-image>
    </div>
    <div class="shop__description">
      <a [routerLink]="utils.isDesktop ? shopUrl : undefined" class="nav-link">
        @if (shop.name) {
          <app-text
            [textSize]="TextSizes.h1Header"
            [textType]="TextType.base"
            [text]="shop.name"
            [initialCase]="true"
          ></app-text>
        }
      </a>
      <div class="contact-wrapper">
        @if (shop.city && shop.house) {
          <div #shopLocation class="flex" (click)="onLinkClick($event)">
            <app-text
              [textSize]="TextSizes.mobInput"
              [textType]="TextType.base"
              [text]="shop.city.name"
            ></app-text>
          </div>
        }
      </div>
    </div>
    @if ({ isLoading: isFavStateLoading$ | async }; as loadingState) {
      <div
        class="shop__fav"
        (click)="onFavClick($event, loadingState.isLoading, shop.id, shop.isFavorite)"
      >
        @if (shop.isFavorite) {
          <app-image [img]="'assets/images/icons-svg/favourite.svg'"></app-image>
        }
        @if (!shop.isFavorite) {
          <app-image [img]="'assets/images/icons-svg/not-favourite.svg'"></app-image>
        }
      </div>
    }
  </a>
}
